import { ContractData, ContractContactData, SiteWebAppData } from 'app/core/hub-api';


export class AddEditBccContactModalContext {
  editMode: boolean;
  contract?: ContractData;
  contractContact?: ContractContactData;
  site: SiteWebAppData;
}
